import Cookies from 'js-cookie';
import { VistaprintAuth } from '@vp/auth-react';
import { currentCulture } from 'src/utils/cultureUtil';
import { isDevelopmentMode } from 'src/utils/tenantUtil';

const DEV_CLIENT_ID = '123c40d93baeb65efcc8b32ad5dafa76'; // Design Tech: Advanced Studio Static Site Dev Client
const CARE_CLIENT_ID = 'tCZE1T00Yk6Uqs4jLO0HtpwLopz8BN7F'; // VP CARE Console

interface AuthInitOptions {
  culture: string;
  options?: {
    connection?: string;
    redirectAfterSignOutCallback?: () => void;
    requireSession?: boolean;
  };
  developmentMode: boolean | { clientID: string; redirectUriOrigin?: string };
}

/**
 * Set up auth
 * @param isCareAgent lets the care agent login using AD
 */
async function initialize(isCareAgent = false, culture?: string) {
  const params: AuthInitOptions = {
    culture: culture || currentCulture,
    developmentMode: isDevelopmentMode() && { clientID: DEV_CLIENT_ID },
    options: { requireSession: true },
  };

  if (isCareAgent) {
    const org = new URLSearchParams(window.location.search).get('org');
    params.options = {
      ...params.options,
      connection: org || 'vistaprintcom-waad',
    };
    params.developmentMode = { clientID: CARE_CLIENT_ID };

    if (typeof window !== 'undefined' && !isDevelopmentMode()) {
      params.developmentMode.redirectUriOrigin = `${window.location.origin}/auth-callback/`;
    }
  }

  return VistaprintAuth.init(params);
}

export const authUtil = {
  initialize,
};

export function getClientID(isCareAgent = false): string {
  if (isDevelopmentMode()) {
    return DEV_CLIENT_ID;
  }
  if (isCareAgent) {
    return DEV_CLIENT_ID;
  }
  const value = Cookies.get('vpconfig');
  return value ? JSON.parse(value).clientId : '';
}
